<template>
  <div>
    <div class="form-group row">
      <label class="col-2 form-control-label"><span class="ess">활선 작업여부</span></label>
      <div class="col-10 pt-2">
        <label class="md-check mr-20"><input type="radio" v-model="permit.liveLineWork" value="해당"><i class="blue"></i>해당</label>
        <label class="md-check"><input type="radio" v-model="permit.liveLineWork" value="해당없음"><i class="blue"></i>해당없음(정전작업)</label>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-2 form-control-label"><span class="ess">작업기간</span></label>
      <div class="col-4 pt-2">
        <DatePicker class="form-control" type="date" range :append-to-body="true"
          :value="permit.workPeriod"
          :clearable="false" :editable="false"
          :disabled-date="scheduleDateDisabledFn"
          @change="(val) => { permit.workPeriod = val; }"
          style="font-size: 12px;" input-class="calendar-input">
          <i slot="icon-calendar" class="icon-calendar" style="color: #222; cursor: pointer"></i>
        </DatePicker>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-2 form-control-label"><span class="ess">작업범위</span></label>
      <div class="col-10 pt-2">
        <input type="text" class="form-control" v-model="permit.workScope">
      </div>
    </div>
    <div class="form-group row">
      <label class="col-2 form-control-label"><span class="ess">작업자 자격확인</span></label>
      <div class="col-10 pt-2">
        <div class="btn-wrap mb-10">
          <button class="btn btn-md light-blue" @click="addElectricWorker">
            <i class="icon-plus mr-5"></i>행 추가
          </button>
        </div>
        <table class="tbl select-tbl">
          <colgroup><col style="width:200px;"><col><col style="width:80px;"></colgroup>
          <thead class="no-drag">
            <tr>
              <th>성명</th>
              <th>자격</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(worker, idx) in permit.workers" :key="idx">
              <td><input type="text" class="form-control" v-model="worker.name" placeholder="성명"></td>
              <td><input type="text" class="form-control" v-model="worker.qualification" placeholder="자격증명"></td>
              <td style="text-align:center;">
                <button class="btn btn-xs line-2" @click="removeElectricWorker(idx)" :disabled="permit.workers.length === 1">삭제</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-2 form-control-label"><span>보호구지급 및 사용장비</span></label>
      <div class="col-10 pt-2">
        <div class="form-group row mb-10">
          <label class="col-2 form-control-label pt-0">
            <span v-tooltip.top="{ content: approachLimitTooltip, html: true, classes: ['wp-approach-tooltip'] }"
                  style="display:inline-flex;align-items:center;justify-content:center;width:15px;height:15px;border-radius:50%;background:#888;color:#fff;font-size:10px;cursor:help;margin-right:4px;">?</span>
            <span class="ess">접근 한계거리(cm)</span>
          </label>
          <div class="col-10"><input type="text" class="form-control" v-model="permit.approachDistance"></div>
        </div>
        <div class="form-group row mb-10">
          <label class="col-2 form-control-label pt-0">지급 보호구</label>
          <div class="col-10">
            <label class="md-check mr-20" v-for="p in electricProtectionTypes" :key="p">
              <input type="checkbox" v-model="permit.protections" :value="p"><i class="blue"></i>{{ p }}
            </label>
            <label class="md-check mr-10">
              <input type="checkbox" v-model="permit.isProtectionOther"><i class="blue"></i>기타보호구
            </label>
            <input v-if="permit.isProtectionOther" type="text" class="form-control mt-5"
                   v-model="permit.protectionOtherText" placeholder="기타 보호구 내용 입력" style="max-width:300px;">
          </div>
        </div>
        <div class="form-group row mb-10">
          <label class="col-2 form-control-label pt-0"><span class="ess">측정장비</span></label>
          <div class="col-10"><input type="text" class="form-control" v-model="permit.measurementEquip"></div>
        </div>
        <div class="form-group row mb-10">
          <label class="col-2 form-control-label pt-0"><span class="ess">활선기구/장비</span></label>
          <div class="col-10"><input type="text" class="form-control" v-model="permit.liveLineEquip"></div>
        </div>
        <div class="form-group row mb-10">
          <label class="col-2 form-control-label pt-0"><span class="ess">방호구</span></label>
          <div class="col-10"><input type="text" class="form-control" v-model="permit.defenseEquip" placeholder="Ex) 절연관, 애자커버, 절연시트 등"></div>
        </div>
        <div class="form-group row mb-0">
          <label class="col-2 form-control-label pt-0">기타</label>
          <div class="col-10"><input type="text" class="form-control" v-model="permit.otherEquip"></div>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-2 form-control-label"><span class="ess">작업순서 및 안전 작업 방법</span></label>
      <div class="col-10 pt-2">
        <WorkProcedureTable :procedures="permit.procedures" @load-procedures="$emit('load-procedures')" />
      </div>
    </div>
    <div class="form-group row">
      <label class="col-2 form-control-label"><span>첨부파일</span></label>
      <div class="col-10 pt-2">
        <div class="mb-10"><strong>설비관련</strong></div>
        <div class="mb-5">
          <label class="md-check mr-20"><input type="checkbox" v-model="permit.attachments.facility" value="전기단선도/결선도"><i class="blue"></i>전기단선도/결선도</label>
          <label class="md-check mr-20"><input type="checkbox" v-model="permit.attachments.facility" value="기기사양서"><i class="blue"></i>기기사양서</label>
          <label class="md-check mr-20"><input type="checkbox" v-model="permit.attachments.facility" value="공사계획표(정전작업 계획 등)"><i class="blue"></i>공사계획표(정전작업 계획 등)</label>
          <label class="md-check mr-10"><input type="checkbox" v-model="permit.attachments.facilityOther"><i class="blue"></i>기타</label>
          <input v-if="permit.attachments.facilityOther" type="text" class="form-control mt-5"
                 v-model="permit.attachments.facilityOtherText" placeholder="기타 설비관련 항목명" style="max-width:300px;">
        </div>
        <div v-if="permit.attachments.facility.length || permit.attachments.facilityOther" class="mt-10 mb-5">
          <div v-for="item in permit.attachments.facility" :key="'ff-'+item" class="wp-attach-row">
            <span class="wp-attach-label">{{ item }}</span>
            <input type="file" @change="(e) => setElectricFile(e, item)">
            <span v-if="permit.attachments.files[item] && permit.attachments.files[item].length" class="text-muted ml-10" style="font-size:11px;">{{ permit.attachments.files[item].map(f => f.name).join(', ') }}</span>
          </div>
          <div v-if="permit.attachments.facilityOther" class="wp-attach-row">
            <span class="wp-attach-label">{{ permit.attachments.facilityOtherText || '기타' }}</span>
            <input type="file" @change="(e) => setElectricFile(e, '설비_기타')">
            <span v-if="permit.attachments.files['설비_기타'] && permit.attachments.files['설비_기타'].length" class="text-muted ml-10" style="font-size:11px;">{{ permit.attachments.files['설비_기타'].map(f => f.name).join(', ') }}</span>
          </div>
        </div>
        <div class="mt-15 mb-10"><strong>안전관련</strong></div>
        <div class="mb-5">
          <label class="md-check mr-20"><input type="checkbox" v-model="permit.attachments.safety" value="비상시 대응조직체계"><i class="blue"></i>비상시 대응조직체계</label>
          <label class="md-check mr-20"><input type="checkbox" v-model="permit.attachments.safety" value="작업계획서 평가 및 관리계획"><i class="blue"></i>작업계획서 평가 및 관리계획</label>
          <label class="md-check mr-10"><input type="checkbox" v-model="permit.attachments.safetyOther"><i class="blue"></i>기타</label>
          <input v-if="permit.attachments.safetyOther" type="text" class="form-control mt-5"
                 v-model="permit.attachments.safetyOtherText" placeholder="기타 안전관련 항목명" style="max-width:300px;">
        </div>
        <div v-if="permit.attachments.safety.length || permit.attachments.safetyOther" class="mt-10">
          <div v-for="item in permit.attachments.safety" :key="'sf-'+item" class="wp-attach-row">
            <span class="wp-attach-label">{{ item }}</span>
            <input type="file" @change="(e) => setElectricFile(e, item)">
            <span v-if="permit.attachments.files[item] && permit.attachments.files[item].length" class="text-muted ml-10" style="font-size:11px;">{{ permit.attachments.files[item].map(f => f.name).join(', ') }}</span>
          </div>
          <div v-if="permit.attachments.safetyOther" class="wp-attach-row">
            <span class="wp-attach-label">{{ permit.attachments.safetyOtherText || '기타' }}</span>
            <input type="file" @change="(e) => setElectricFile(e, '안전_기타')">
            <span v-if="permit.attachments.files['안전_기타'] && permit.attachments.files['안전_기타'].length" class="text-muted ml-10" style="font-size:11px;">{{ permit.attachments.files['안전_기타'].map(f => f.name).join(', ') }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WorkProcedureTable from './WorkProcedureTable.vue';
import docFileUploadMixin from '@/mixins/docFileUploadMixin';

export default {
  name: 'ElectricWorkPermit',
  components: { WorkProcedureTable },
  mixins: [docFileUploadMixin],
  inject: { workPermitPlanId: { default: () => '' } },
  props: {
    permit: {
      type: Object,
      required: true
    },
    scheduleDateDisabledFn: {
      type: Function,
      default: () => false
    }
  },
  data() {
    return {
      workPermitFormKey: 'electricWorkPermit',
      electricProtectionTypes: ['절연안전모(ABE)', '안전화', '절연장화', '절연장갑', '보안경', '안전대'],
      // <표 1> 충전부의 접근한계 [선간전압, 접근한계거리, 노출된 이동도체, 노출된 고정전로]
      approachLimitRows: [
        ['0.3 이하', '접촉금지', '305', '107'],
        ['0.3 초과 0.75 이하', '30', '305', '107'],
        ['0.75 초과 2 이하', '45', '305', '153'],
        ['2 초과 15 이하', '60', '305', '153'],
        ['15 초과 37 이하', '90', '305', '183'],
        ['37 초과 88 이하', '110', '305', '244'],
        ['88 초과 121 이하', '130', '305', '244'],
        ['121 초과 145 이하', '150', '336', '305'],
        ['145 초과 169 이하', '170', '356', '356'],
        ['169 초과 242 이하', '230', '397', '397'],
        ['242 초과 362 이하', '380', '468', '468'],
        ['362 초과 550 이하', '550', '580', '580'],
        ['550 초과 800 이하', '790', '724', '724']
      ]
    }
  },
  computed: {
    approachLimitTooltip() {
      const c = 'border:1px solid #b0b0b0;padding:2px 6px;text-align:center;white-space:nowrap;';
      const cl = 'border:1px solid #b0b0b0;padding:2px 6px;text-align:left;white-space:nowrap;';
      const body = this.approachLimitRows.map((r) =>
        '<tr>'
        + '<td style="' + cl + '">' + r[0] + '</td>'
        + '<td style="' + c + '">' + r[1] + '</td>'
        + '<td style="' + c + '">' + r[2] + '</td>'
        + '<td style="' + c + '">' + r[3] + '</td>'
        + '</tr>'
      ).join('');
      return '<div style="font-size:11px;line-height:1.35;">'
        + '<div style="font-weight:bold;margin-bottom:5px;">&lt;표 1&gt; 충전부의 접근한계 (전격방지를 위한 충전부와 작업자 사이 거리)</div>'
        + '<table style="border-collapse:collapse;margin:0 auto;">'
        + '<tr>'
        + '<th style="' + c + '" rowspan="2">충전전로의<br>선간전압(kV)</th>'
        + '<th style="' + c + '" rowspan="2">접근한계거리<br>(cm)</th>'
        + '<th style="' + c + '" colspan="2">접근제한거리(cm)</th>'
        + '</tr>'
        + '<tr>'
        + '<th style="' + c + '">노출된<br>이동도체</th>'
        + '<th style="' + c + '">노출된<br>고정전로</th>'
        + '</tr>'
        + body
        + '</table>'
        + '<div style="margin-top:5px;">주) 자세한 사항은 KOSHA GUIDE \'활선작업 및 활선근접작업에 관한 기술지침\'을 참조</div>'
        + '</div>';
    }
  },
  methods: {
    addElectricWorker() {
      this.permit.workers.push({ name: '', qualification: '' });
    },
    removeElectricWorker(idx) {
      if (this.permit.workers.length <= 1) return;
      this.permit.workers.splice(idx, 1);
    },
    setElectricFile(event, key) {
      this.$set(this.permit.attachments.files, key, []);
      this.handleDocFile(event, { key: 'electric-' + key, files: this.permit.attachments.files[key] });
    }
  }
}
</script>